import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuthUser } from '@nbx/frontend-helpers/subscribe';
import Main from 'components/app/Main';
import PageTwoColumns from 'components/app/PageTwoColumns';
import ButtonPrimary from 'components/shared/ButtonPrimary';
import Text from 'components/shared/Text';
import Heading from 'components/shared/Heading';
import { useIsMobile } from 'helpers/hooks';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

const microapps = window.MICROFRONTENDS_CONFIG;

function ErrorMessage({ clearError }) {
  const { t } = useTranslation();
  const user = useAuthUser();
  const isMobile = useIsMobile();

  useEffect(() => {
    const unlisten = window.HISTORY.listen(clearError);
    return () => unlisten();
  }, []); // eslint-disable-line

  return (
    <Main>
      <PageTwoColumns>
        <Heading tag="h1">{t('error_title_generic')}</Heading>
        <Text tag="p" muted centered={isMobile} styles={[styles.blurb]}>
          {t('It looks like we hit a snag')}
        </Text>
        <ButtonPrimary
          href={user ? microapps.routes.dashboards.path : microapps.routes.login.path}
          noTarget
          onClick={clearError}
          fullWidth={isMobile}>
          {t('error_button_go_home')}
        </ButtonPrimary>
      </PageTwoColumns>
    </Main>
  );
}

ErrorMessage.propTypes = {
  clearError: PropTypes.func
};

ErrorMessage.defaultProps = {
  clearError: PropTypes.func.isRequired
};

export default ErrorMessage;
